import { ReactNode, useMemo } from 'react';
import {
  ApolloClient,
  ApolloProvider,
  HttpLink,
  InMemoryCache,
  split,
} from '@apollo/client';
import { WebSocketLink } from '@apollo/client/link/ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import { useBehaviour } from '../providers/BehaviourProvider';

type Props = { children: ReactNode; token?: string };

export const ApiProvider = ({ children, token }: Props) => {
  const { apiUrl, wsApiUrl } = useBehaviour();

  const authLink = {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  };

  const client = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let config: any = {
      uri: apiUrl! + '/graphql',
      ...authLink,
    };

    if (wsApiUrl) {
      const httpLink = new HttpLink({
        uri: apiUrl + '/graphql',
        ...authLink,
      });

      const wsLink = new WebSocketLink(
        new SubscriptionClient(wsApiUrl + '/graphql', {
          reconnect: true,
          connectionParams: authLink,
        }),
      );

      config = {
        link: split(
          ({ query }) => {
            const definition = getMainDefinition(query);
            return (
              definition.kind === 'OperationDefinition' &&
              definition.operation === 'subscription'
            );
          },
          wsLink,
          httpLink,
        ),
      };
    }

    return new ApolloClient({
      ...config,
      cache: new InMemoryCache({ addTypename: false }),
    });
  }, []);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
